export default __webpack_public_path__ + "media/images/features/ja/main_box_grass-69b7f2946175a57a363f22b13ffe8da0.png";